import React from "react";
import useGetForReviewInvoiceCount from "../../ForReview/hooks/useGetForReviewInvoiceCount";
import useGetUnverifiedInvoiceCount from "../../InvoiceCapture/hooks/useGetUnverifiedInvoiceCount";
import useGetApprovedInvoiceCount from "../../SubmittedToAcumatica/hooks/useGetApprovedInvoiceCount";
import useGetVoidedInvoiceCount from "../../Voided/hooks/useGetVoidedInvoiceCount";
import { AllUnapprovedInvoicesCard } from "../cards/AllUnapprovedInvoicesCard";
import { AllUnsubmittedInvoicesCard } from "../cards/AllUnsubmittedInvoicesCard";
import { UnassignedInvoicesCard } from "../cards/UnassignedInvoicesCard";
import { UnverifiedCaptureCard } from "../cards/UnverifiedCaptureCard";
import { ReconciliationInvoicesCard } from "../cards/ReconciliationInvoicesCard";
import useGetReconciliationCount from "../../Reconcilliation/hooks/useGetReconcilationCount";
interface Props {}
export const ActiveInvoiceDetails: React.FC<Props> = () => {
  const { data: voided } = useGetVoidedInvoiceCount();
  const { data: unverified } = useGetUnverifiedInvoiceCount();
  const { data: forReview } = useGetForReviewInvoiceCount();
  const { data: approved } = useGetApprovedInvoiceCount();
  const { data: reconciliation } = useGetReconciliationCount();

  return (
    <>
      <h1 className="mr-auto font-bold text-primary text-md mb-2">
        Active Invoice
      </h1>
      <div className="grid gap-3 grid-cols-5">
        <UnverifiedCaptureCard count={unverified} />
        <UnassignedInvoicesCard count={forReview} />
        <ReconciliationInvoicesCard count={reconciliation} />
        <AllUnsubmittedInvoicesCard count={approved} />
        <AllUnapprovedInvoicesCard count={voided} />
      </div>
    </>
  );
};
